import React, { useEffect, useState } from 'react';
import styles from '../../assets/RegisterrLoader.module.css';

const LoadingComponent = () => {
    const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={styles.maindiv}>
      <div className={styles["loading-container"]}>
        <div className={styles["loading-text"]}>
          <span>L</span>
          <span>O</span>
          <span>A</span>
          <span>D</span>
          <span>I</span>
          <span>N</span>
          <span>G</span>
        </div>
      </div>
      <div className={styles.socials}>
    <div className={styles.loadingMessage}>
          Fetching Submissions, please wait ({seconds} seconds).It may take a maximum of 100 seconds.
        </div>
        <a className={styles["social-link"]} href="https://twitter.com/aybukeceylan" target="_top">
          {/* Twitter SVG */}
        </a>
        <a className={styles["social-link"]} href="https://www.linkedin.com/in/ayb%C3%BCkeceylan/" target="_top">
          {/* LinkedIn SVG */}
        </a>
      </div>
    </div>
  );
};

export default LoadingComponent;
